import React, { useEffect, useState } from "react";
import leftArrow from "../../assets/img/left-arrow.png";
import rigthArrow from "../../assets/img/right-arrow.png";
import { useNavigate } from "react-router-dom";
import addIcon from "../../assets/img/addUser.png";
import deleteIcon from "../../assets/img/delete.svg";
// import searchIcon from "../../common/assets/img/search.png";
import searchIcon from "../../assets/img/search.png";
import Images from "../../assets";
import axios from "axios";
import logo from "../../assets/img/timber_logo.png";
import { useMutation } from "react-query";
import { useQuery } from "react-query";
import PopUpModal from "../popupmodal/PopUpModal";
import moment from "moment/moment";
import { useDispatch } from "react-redux";
import { copydocument, formdataDetails } from "../../Redux/Actions";

const fetchFileName = async (searchTerm) => {
  const response = await axios.get(
    `https://api.2kvirtualworld.com/BESTTIMBERSDEV/invoices/byfilename?fileName=${searchTerm}`
  );
  return response.data;
};

const fetchBillNo = async (searchTerm) => {
  const response = await axios.get(
    `https://api.2kvirtualworld.com/BESTTIMBERSDEV/invoices/byblno?blNo=${searchTerm}`
  );
  return response.data;
};

const DatamanagementTable = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedData, setSelectedData] = useState(null);
  const recordsPerPage = 9; // Number of records per page
  const [isSearching, setIsSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  const [deleteIndex, setDeleteIndex] = useState([]);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [deletePopUp, setDeletePopUp] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isNextClicked, setIsNextClicked] = useState(false);

  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);
  };

  // Function to handle search button click
  const handleSearchClick = () => {
    if (searchTerm.trim()) {
      setDebouncedSearchTerm(searchTerm?.trim());
      setIsSearching(true);
    }
  };
  // Function to handle search box cleanup
  const handleClearSearch = () => {
    setSearchTerm("");
    setDebouncedSearchTerm("");
    setIsSearching(false);
  };

  const fetchDataManagement = async (page) => {
    if (isNextClicked) setIsPageLoading(true); // Start loading only for "Next"

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_HOST}/getInvoiceFields/bypage?page=${page}&size=${recordsPerPage}`
      );

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          alert(error.response.data?.message || "No records found.");
        }
      } else {
        alert("An unexpected error occurred.");
      }
      throw error; // Ensures React Query still detects an error
    } finally {
      setIsPageLoading(false); // Stop loading after fetch
      setIsNextClicked(false); // Reset next page click tracking
    }
  };

  // React Query hook to fetch paginated data
  const {
    data: paginatedData,
    isLoading,
    isError,
    refetch,
  } = useQuery(["data", currentPage], () => fetchDataManagement(currentPage), {
    keepPreviousData: true,
    enabled: !isSearching,
  });

  // React Query hook to fetch bill details, only if searchTerm is available
  const { data: fetchBill, isLoading: loadingBillNo } = useQuery(
    ["fetchBillNo", debouncedSearchTerm],
    () => fetchBillNo(debouncedSearchTerm),

    {
      enabled: !!debouncedSearchTerm, // Only enable the query if searchTerm is not empty
    }
  );

  // React Query hook to fetch file details based on the debounced search term
  const { data: fetchFile, isLoading: loadingFileName } = useQuery(
    ["fetchFileName", debouncedSearchTerm],
    () => fetchFileName(debouncedSearchTerm),
    {
      enabled: !!debouncedSearchTerm, // Only trigger the query when the search term is not empty
    }
  );

  useEffect(() => {
    let normalizedData = [];
    if (fetchFile) {
      normalizedData = Array.isArray(fetchFile) ? fetchFile : [fetchFile];
    } else if (fetchBill) {
      normalizedData = Array.isArray(fetchBill) ? fetchBill : [fetchBill];
    }
    setSelectedData(normalizedData);
    setIsSearching(false); // Reset searching after data fetch
  }, [fetchFile, fetchBill]);

  // Extract the details of records from the fetched data
  const details = paginatedData?.content || [];

  const getBlNumbersById = (deleteIndex) => {
    return (
      details &&
      details
        ?.filter((item) => deleteIndex?.includes(item.id)) // Check if item's id is in the provided ids array
        .map((item) => item.blNo)
    ); // Extract blNo values from the matching objects
  };
  const blNumbers = getBlNumbersById(deleteIndex);

  // Determine if pagination buttons should be disabled
  const isPrevDisabled = currentPage === 0; // Disable "Prev" on the first page
  const isNextDisabled = details?.length < recordsPerPage; // Disable "Next" if less than 10 records are fetched

  // Handler for the "Prev" button
  const handlePrevPage = () => {
    if (!isPrevDisabled) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  // Handler for the "Next" button
  const handleNextPage = () => {
    if (!isNextDisabled) {
      setIsNextClicked(true);
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handleCheckboxChange = (id) => {
    if (deleteIndex?.includes(id)) {
      // If the ID is already in the deleteIndex array, remove it
      setDeleteIndex(deleteIndex.filter((item) => item !== id));
    } else {
      // Otherwise, add the ID to the deleteIndex array
      setDeleteIndex([...deleteIndex, id]);
    }
  };

  // const HandlerDelete = async () => {
  //   try {
  //     // Ensure deleteIndex is used correctly
  //     const response = await axios.delete(
  //       `${process.env.REACT_APP_HOST}/invoices/delete`,
  //       {
  //         data: deleteIndex, // Assuming the backend expects an array of IDs in the body
  //       }
  //     );
  //     const responses = await axios.delete(
  //       `https://api.2kvirtualworld.com/bestTimbers/copydocuments/deleteByBlNos`,
  //       {
  //         data: blNumbers, // Assuming the backend expects an array of IDs in the body
  //       }
  //     );

  //     console.log("Delete response:", response.data);

  //     // Refetch data
  //     refetch();
  //     // Close popups and reset states

  //     setPopupOpen(false);
  //     setDeleteIndex([]); // Clear the deleteIndex
  //     return response.data;
  //   } catch (error) {
  //     console.log("Error", error);
  //   }
  // };

  const handleDelete = async () => {
    try {
      // Ensure deleteIndex and blNumbers are used correctly
      await axios.delete(`${process.env.REACT_APP_HOST}/invoices/delete`, {
        data: deleteIndex,
      });

      setPopupOpen(false);

      setTimeout(() => {
        setDeletePopUp(true);
      }, 100);

      // Refetch data
      refetch();

      // Clear deleteIndex after successful deletion
      setDeleteIndex([]);
    } catch (error) {
      console.error("Error deleting records:", error);
    }
  };

  // COPY DOC API GET START

  // const Copydoc = useQuery(["data", copyid], fetchcopydoc, {
  //   enabled: isheat,
  //   onSuccess: () => {
  //     setIsheat(false);
  //   },
  //   onError: () => {
  //     setIsheat(false);
  //   },
  // });

  const [copyid, setcopyId] = useState(null);
  const [isheat, setIsheat] = useState(false);
  const [selectBlNo, setSelectBlNo] = useState(null);
  const [loadingIndex, setLoadingIndex] = useState(null); // To track the row index that is loading

  const dispatch = useDispatch();

  // Fetch Copy Document API
  const fetchcopydoc = async () => {
    if (copyid) {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_HOST}/copydocuments/${copyid}`
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching copy document:", error);
        return null;
      }
    }
    return null;
  };

  const {
    data: copyDoc,
    error: copyDocError,
    isFetching: isFetchingCopyDoc,
    isSuccess: isSuccessCopyDoc,
  } = useQuery(["fetchcopydoc", copyid], fetchcopydoc, {
    enabled: isheat,
  });

  // Fetch BL Data API
  const fetchDataByBlNo = async (blno) => {
    console.log("Fetching BL data with blNo:", blno);
    if (blno) {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_HOST}/invoices/byblno?blNo=${blno}`
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching BL data:", error);
        return null;
      }
    }
    return null;
  };

  const {
    data: blData,
    error: blError,
    isLoading: blDataLoading,
    isFetching: isFetchingBlData,
    isSuccess: isSuccessBlData, // Track success status for BL data
  } = useQuery(
    ["fetchDataByBlNo", selectBlNo],
    () => fetchDataByBlNo(selectBlNo),
    {
      enabled: !!selectBlNo,
    }
  );

  let fetchedData = blData;

  const HandlerEdit = async (val, index) => {
    setLoadingIndex(index); // Set the current row index as loading
    if (val?.blNo) {
      setcopyId(val?.blNo);
      setSelectBlNo(val?.blNo);
      setIsheat(true);
    }
  };

  // Trigger navigation when both data (copyDoc and blData) are successfully loaded
  useEffect(() => {
    if (isSuccessCopyDoc && isSuccessBlData) {
      if (copyDoc && copyDoc?.copyDocumentsList) {
        dispatch(copydocument(copyDoc?.copyDocumentsList));
      }
      if (fetchedData) {
        dispatch(formdataDetails(fetchedData));
      }

      navigate("/dataEntryForm", { state: fetchedData });
    }
  }, [
    isSuccessCopyDoc,
    isSuccessBlData,
    copyDoc,
    fetchedData,
    dispatch,
    navigate,
  ]);

  return (
    <>
      <div className="headerTimeLine  px-3 py-3">
        <div className="row g-3">
          <div className="col-12 col-lg-6">
            <div className="d-flex align-items-center gap-2">
              <input
                type="search"
                className="--new-search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search by BL No, File Name"
                title="Search by BL No, File Name"
              />

              <div className="search-button" onClick={handleSearchClick}>
                <img
                  src={searchIcon}
                  style={{ width: "100%", height: "100%" }}
                  alt="search"
                />
              </div>

              {searchTerm && (
                <button
                  onClick={handleClearSearch}
                  className="btn btn-outline-secondary"
                >
                  Clear
                </button>
              )}
            </div>
          </div>

          <div className="col-12 col-lg-6">
            <div className="d-flex flex-wrap align-items-center justify-content-lg-end gap-3">
              <div
                className="add-user-btn-block gap-2"
                onClick={() => navigate("/dataEntryForm")}
              >
                <button className="new-user-btn">NEW DATA ENTRY</button>
                <div style={{ width: "20px", height: "20px" }}>
                  <img src={addIcon} className="img-icon" alt="add" />
                </div>
              </div>

              {deleteIndex?.length !== 0 && (
                <div
                  className="add-user-btn-block gap-2"
                  onClick={() => setPopupOpen(true)}
                >
                  <button className="new-user-btn">DELETE</button>
                  <div style={{ width: "20px", height: "20px" }}>
                    <img src={deleteIcon} className="img-icon" alt="delete" />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="view-table-block d-flex flex-column">
        <div className="table-responsive agent-management-table">
          <table className="view-user-table">
            <thead>
              <tr>
                <td className="view-user-table-head --first-head">
                  SELECT/EDIT
                </td>
                <td className="view-user-table-head">FILE NAME</td>
                <td className="view-user-table-head">REMAINING DAYS</td>
                <td className="view-user-table-head">BL NO</td>

                <td className="view-user-table-head">EXPORTER</td>
                <td className="view-user-table-head">INVOICE NO</td>
                <td className="view-user-table-head">BE NO</td>
                <td className="view-user-table-head --last-head">
                  BG NUMBER & DATE
                </td>
                {/* <td className="view-user-table-head --last-head"></td> */}
              </tr>
            </thead>
            <tbody
              className={
                isLoading || loadingBillNo || loadingFileName
                  ? "loading_body"
                  : ""
              }
            >
              {isLoading || loadingBillNo || loadingFileName ? (
                <tr>
                  <td
                    colSpan="8"
                    style={{
                      textAlign: "center",
                      position: "relative",
                      height: "180px",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        width: "300px",
                        margin: "0 auto",
                      }}
                    >
                      <div className="loading" /> {/* CSS spinner */}
                      <img
                        alt="logo"
                        src={Images.logo}
                        style={{
                          opacity: 0.7,
                          width: "100%",
                          height: "auto",
                          position: "absolute",
                          top: 0,
                          left: 0,
                        }}
                      />
                    </div>
                  </td>
                </tr>
              ) : isError ? (
                <tr>
                  <td
                    colSpan="8"
                    style={{
                      textAlign: "center",
                      color: "#000",
                      fontSize: "18px",
                      fontWeight: 800,
                    }}
                  >
                    No Network...
                  </td>
                </tr>
              ) : selectedData && selectedData?.length > 0 ? (
                selectedData?.map((val, i) => (
                  <tr key={i} className="view-user-table-row">
                    <td className="view-user-table-data">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <input
                          id="myCheckbox"
                          type="checkbox"
                          checked={deleteIndex.includes(val.id)}
                          onChange={() => handleCheckboxChange(val.id)}
                        />
                        <div
                          onClick={() => HandlerEdit(val, i)}
                          style={{
                            width: "40px",
                            height: "30px",
                          }}
                          className="d-flex justify-content-center align-items-center"
                        >
                          {loadingIndex === i && isFetchingBlData ? (
                            <i className="fa fa-circle-o-notch fa-spin"></i>
                          ) : (
                            <img
                              src={Images?.editpencil}
                              style={{ width: "100%", height: "100%" }}
                              alt="Edit"
                            />
                          )}
                        </div>
                      </div>
                    </td>
                    <td className="view-user-table-data">
                      {val?.fileName || "-"}
                    </td>
                    <td className="view-user-table-data">
                      {val?.remainingDays || "-"}
                    </td>
                    <td className="view-user-table-data">{val?.blNo || "-"}</td>

                    <td className="view-user-table-data">
                      {val?.exporter || "-"}
                    </td>
                    <td className="view-user-table-data">
                      {val?.invoiceNo || "-"}
                    </td>
                    <td className="view-user-table-data">{val?.beNo || "-"}</td>
                    <td className="view-user-table-data">
                      {val?.bgNumber || val?.bgdate
                        ? `${val?.bgNumber || "-"} / ${
                            val?.bgdate
                              ? moment(val?.bgdate).format("DD-MM-YYYY")
                              : "-"
                          }`
                        : "-"}
                    </td>
                  </tr>
                ))
              ) : details && details?.length > 0 ? (
                details?.map((val, i) => (
                  <tr key={i} className="view-user-table-row">
                    <td className="view-user-table-data">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <input
                          id="myCheckbox"
                          type="checkbox"
                          checked={deleteIndex.includes(val.id)}
                          onChange={() => handleCheckboxChange(val.id)}
                          style={{ width: "20px", height: "20px" }}
                        />
                        <div
                          onClick={() => HandlerEdit(val, i)}
                          style={{
                            width: "40px",
                            height: "30px",
                          }}
                          className="d-flex justify-content-center align-items-center"
                        >
                          {loadingIndex === i && isFetchingBlData ? (
                            <i className="fa fa-circle-o-notch fa-spin"></i>
                          ) : (
                            <img
                              src={Images?.editpencil}
                              style={{ width: "100%", height: "100%" }}
                              alt="Edit"
                            />
                          )}
                        </div>
                      </div>
                    </td>
                    <td className="view-user-table-data">
                      {val?.fileName || "-"}
                    </td>
                    <td className="view-user-table-data">
                      {val?.remainingDays || "-"}
                    </td>
                    <td className="view-user-table-data">{val?.blNo || "-"}</td>
                    <td className="view-user-table-data">
                      {val?.exporter || "-"}
                    </td>
                    <td className="view-user-table-data">
                      {val?.invoiceNo || "-"}
                    </td>
                    <td className="view-user-table-data">{val?.beNo || "-"}</td>
                    <td className="view-user-table-data">
                      {val?.bgNumber || val?.bgdate
                        ? `${val?.bgNumber || "-"} / ${
                            val?.bgdate
                              ? moment(val?.bgdate).format("DD-MM-YYYY")
                              : "-"
                          }`
                        : "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    No results found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <footer className="table-bottom" style={{ width: "90%" }}>
          <button
            onClick={handlePrevPage}
            disabled={isPrevDisabled || isPageLoading}
            className="arrow-btn"
          >
            &lt;
          </button>
          <button
            onClick={handleNextPage}
            // disabled={isNextDisabled}
            disabled={isNextDisabled || isPageLoading} //  Disable when loading
            className="arrow-btn"
          >
            {isPageLoading ? (
              <i className="fa fa-spinner fa-spin"></i>
            ) : (
              <>&gt;</>
            )}
          </button>
        </footer>
      </div>

      <PopUpModal isOpen={isPopupOpen} onClose={togglePopup}>
        <div className="img-block">
          <div style={{ width: "40%", height: "60%" }} className="mx-2 pt-2">
            <img
              src={logo}
              style={{ width: "100%", height: "100%" }}
              alt="logo"
            />
          </div>
        </div>
        <div className="d-flex flex-column align-items-center justify-content-center py-1">
          <h6 className="popup-content mb-3">
            Are you sure you want to delete this detail?
          </h6>
          <div className="d-flex justify-content-center gap-5 mb-3">
            <button className="user-delete-button" onClick={handleDelete}>
              OK
            </button>
            <button className="user-delete-button" onClick={togglePopup}>
              NO
            </button>
          </div>
        </div>
      </PopUpModal>

      {/* Success Popup */}
      <PopUpModal isOpen={deletePopUp} onClose={() => setDeletePopUp(false)}>
        <div className="img-block">
          <div style={{ width: "40%", height: "60%" }} className="mx-2 pt-2">
            <img
              src={logo}
              style={{ width: "100%", height: "100%" }}
              alt="logo"
            />
          </div>
        </div>
        <div className="d-flex flex-column align-items-center justify-content-center py-1">
          <h6 className="popup-content mb-3">
            Form Has Been deleted successfully
          </h6>
          <button
            className="user-delete-button mb-3"
            onClick={() => {
              setDeletePopUp(false);
              window.location.reload();
              navigate("/");
            }}
          >
            OK
          </button>
        </div>
      </PopUpModal>
    </>
  );
};

export default DatamanagementTable;
